import React from "react";
import { useNavigate } from "react-router-dom"; // If using react-router for navigation

const ThankYouPage = () => {
  const history = useNavigate(); // Hook to navigate to other pages

  const handleBackHome = () => {
    history("/"); // Navigate to homepage or another route
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Thank You!</h1>
      <p style={styles.message}>
        We appreciate your submission. We will get back to you shortly.
      </p>
      <button style={styles.button} onClick={handleBackHome}>
        Go to Homepage
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f8ff",
    textAlign: "center",
  },
  title: {
    fontSize: "36px",
    color: "#4caf50",
    marginBottom: "20px",
  },
  message: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "30px",
    maxWidth: "600px",
    lineHeight: "1.6",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#4caf50",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
};

export default ThankYouPage;
